<app-sheet-form
  class="view"
  id="sheet-form-panel"
  [sheet]="workbook()"
  [inEditor]="!isTemplate()"
  [openCreated]="openInPanel"
  [tab]="tab()"
  (tabChanged)="tabChanged.emit($event)"
  [dp]="true"
  (close)="closed.emit()"
  (back)="closed.emit()"
  (openInMain)="openInMain()"
>
  <!-- Keyed on the workbook's id, NOT `@if`-ed on it: an editor reads the id it is to open once, at
       mount, so Angular reusing this one across a swap left the previous workbook's engine and save
       machine running under the new workbook's header — the grid, the "In Trash" banner and every
       edit still belonged to the workbook that had gone. `@for` over the one id destroys and rebuilds
       it when that id changes, which is what a swap needs; an empty list is a template, which gets no
       editor at all. -->
  @for (id of editorKey(); track id) {
    <app-sheets-editor
      [workbookId]="id"
      [sheetId]="sheetId()"
      [cell]="cell()"
      (activeSheetChanged)="activeSheetChanged.emit($event)"
      (activeCellChanged)="activeCellChanged.emit($event)"
      (closeRequested)="closed.emit()"
    />
  }
</app-sheet-form>
